module.exports = __webpack_public_path__ + "static/media/hourglass-bottom.f178ba22.svg";